document.addEventListener("DOMContentLoaded", () => {
  const currentUrl = window.location.href;
  const urlObject = new URL(window.location);
  const loadedPage = urlObject.searchParams.get("page");

  //get product position from sessionStorage, used to navigate back to last viewed product
  let productPosition = null;
  if (sessionStorage.getItem("productPosition")) {
    productPosition = parseInt(sessionStorage.getItem("productPosition"));
    sessionStorage.removeItem("productPosition");
  }

  if (loadedPage != null) {
    let productGrid = document.getElementById("product-grid");
    productGrid.innerHTML = "";
    let currentPageNumber = parseInt(loadedPage);
    let newUrl = new URL(currentUrl);
    let urlsToFetch = [];

    //get all urls for previous pages and store in array
    for (let i = currentPageNumber; i >= 1; i--) {
      newUrl.searchParams.set("page", i);
      let urlToFetch = newUrl.href;
      urlsToFetch.push(urlToFetch);
    }

    //resolve all fetches in one so that the products are rendered in order
    Promise.all(urlsToFetch.map((url) => fetch(url).then((resp) => resp.text()))).then((texts) => {
      texts.forEach((responseText) => {
        const html = responseText;
        const parsedResponse = new DOMParser().parseFromString(html, "text/html");
        const productGrid = parsedResponse.getElementById("product-grid");
        const ogProductGrid = document.getElementById("product-grid");

        for (c = productGrid.children.length - 1; c >= 0; c--) {
          ogProductGrid.prepend(productGrid.children[c]);
        }
      });

      addPosToHrefs();

      //scroll to product if position was saved
      if (productPosition != null) {
        const ogProductGrid = document.getElementById("product-grid");
        productPosition--;
        let allNewChildren = ogProductGrid.children;
        allNewChildren[productPosition].scrollIntoView();
      }
    });
  } else {
    addPosToHrefs();
  }

  function addPosToHrefs() {
    let productGrid = document.getElementById("product-grid");
    //add _pos attribute to hrefs if it doesn;t already exist
    let productGridChildrenUpdated = Array.from(productGrid.children);
    productGridChildrenUpdated.forEach((child, index) => {
      let link = child.querySelector("a");
      if(link){
        let href = link.href;
        let urlObject = new URL(href);
        let pos = urlObject.searchParams.get("_pos");
        if (pos == null) {
          urlObject.searchParams.set("_pos", index);
          link.href = urlObject.href;
        }
    }
    });
  }
});
